import axios from 'axios'
import gsap from 'gsap'
import Swiper from 'swiper'
import { validateRecaptcha } from 'utility/recaptcha'

const productPage = {
  el: {
    slider: document.querySelector<HTMLElement>('.product-page__picture-slider'),
    thumbnails: document.querySelectorAll<HTMLElement>('.product-page__picture-thumbnail'),
    stockNotification: document.querySelector<HTMLElement>('.product-page__stock-notification'),
  },

  swiper: null,

  init(): void {
    if (this.el.slider) {
      this.initSlider()
      this.handleThumbnails()
    }

    if (this.el.stockNotification) {
      this.handleStockNotification(this.el.stockNotification)
    }
  },

  initSlider(): void {
    this.swiper = new Swiper(this.el.slider, {
      grabCursor: true,
      initialSlide: 0,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 456,
    })
  },

  handleThumbnails(): void {
    this.el.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault()
        this.swiper.slideToLoop(index)
      })
    })

    this.swiper.on('slideChange', () => {
      this.el.thumbnails.forEach((thumbnail) => {
        thumbnail.classList.remove('product-page__picture-thumbnail--active')
      })

      this.el.thumbnails[this.swiper.realIndex].classList.add('product-page__picture-thumbnail--active')
    })
  },

  handleStockNotification(target): void {
    const el = {
      button: target.querySelector('.product-page__stock-notification-form .button'),
      error: target.querySelector('.input-group__error'),
      form: target.querySelector('.product-page__stock-notification-form'),
      input: target.querySelector('.input-group'),
      thankYou: target.querySelector('.product-page__stock-notification-thank-you'),
    }

    const method = {
      init(): void {
        el.form.addEventListener('submit', (event) => {
          validateRecaptcha(event, method.submitForm.bind(this))
        })
      },

      hideError(): void {
        el.input.classList.remove('input-group--error')
        el.error.innerexTt = ''
        document.removeEventListener('click', this.hideError.bind(this))
      },

      renderError(error): void {
        el.input.classList.add('input-group--error')
        el.error.innerText = error
        el.button.classList.remove('button--loading')
        el.button.removeAttribute('disabled')
        document.addEventListener('click', this.hideError.bind(this))
      },

      renderSuccess(): void {
        gsap
          .timeline()
          .to(el.form, {
            duration: 0.321,
            onComplete: () => {
              el.form.remove()
            },
            opacity: 0,
          })
          .set(el.thankYou, {
            display: 'block',
            opacity: 0,
          })
          .to(el.thankYou, {
            duration: 0.321,
            opacity: 1,
          })
      },

      async submitForm(event, token): Promise<void> {
        event.preventDefault()

        const action = event.target.action
        const data = new FormData(event.target)

        data.append('g-recaptcha-response', token)

        el.button.setAttribute('disabled', 'true')
        el.button.classList.add('button--loading')

        await axios
          .post(action, data)
          .then((response) => {
            if (response.status === 200) {
              setTimeout(() => {
                this.renderSuccess()
              }, 567)
            }
          })
          .catch((error) => {
            console.log(`submitForm error: ${error}`)
            this.renderError(error)
          })
      },
    }

    method.init()
  },
}

export default productPage
